import { render, staticRenderFns } from "./RecBalanceBackList.vue?vue&type=template&id=2640beb2"
import script from "./RecBalanceBackList.vue?vue&type=script&lang=js"
export * from "./RecBalanceBackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports